module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: 'detail'
  }, [(_vm.showCutscenes) ? _c('Cutscenes') : _vm._e(), _vm._v(" "), _c('DownloadNav', {
    attrs: {
      "ifShow": _vm.ifShow
    }
  }), _vm._v(" "), _c('div', {
    class: 'detail-content'
  }, [(_vm.poData && _vm.poData.images.length && !_vm.isVideo) ? _c('div', {
    staticClass: "swipe-box"
  }, [_c('Swipe', {
    staticClass: "swipe-content",
    attrs: {
      "showIndicators": false,
      "auto": 0,
      "continuous": false
    },
    on: {
      "change": _vm.handleChange
    }
  }, _vm._l((_vm.poData.images), function(item, index) {
    return _c('SwipeItem', {
      key: item.url,
      attrs: {
        "alt": index
      }
    }, [_c('div', {
      staticClass: "carouse-item",
      style: (("background-image:url(" + (item.hd_url) + ")"))
    })])
  }), 1), _vm._v(" "), _c('div', {
    staticClass: "post-info-bottom"
  }, [_c('div', {
    staticClass: "post-info-left"
  }, [_c('div', {
    staticClass: "likers"
  }, _vm._l((_vm.poData.praise), function(item, index) {
    return (index < 3) ? _c('img', {
      key: index,
      staticClass: "likers-avatar",
      attrs: {
        "src": item.face,
        "alt": "",
        "srcset": ""
      }
    }) : _vm._e()
  }), 0), _vm._v(" "), (parseInt(_vm.poData.praise_count) != 0) ? _c('span', [_vm._v(_vm._s(_vm.poData.praise_count) + "赞")]) : _vm._e(), _vm._v(" "), (parseInt(_vm.poData.collect_count) != 0) ? _c('span', [_vm._v(_vm._s(_vm.poData.collect_count) + "收藏")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "post-info-right"
  }, [_c('span', [_vm._v(_vm._s(_vm.poData.views) + "阅读")])])]), _vm._v(" "), (_vm.poData.images.length > 1) ? _c('span', {
    staticClass: "indicators"
  }, [_vm._v("\n          " + _vm._s(_vm.poData.images.length > 1 ? _vm.swipeIndex + 1 : 1) + "/" + _vm._s(_vm.poData.images.length) + "\n        ")]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.poData && _vm.isVideo) ? _c('div', {
    class: 'video ' + (_vm.playing ? 'full' : '')
  }, [_c('video', {
    ref: "video",
    attrs: {
      "webkit-playsinline": "",
      "playsinline": "",
      "x5-playsinline": "",
      "x-webkit-airplay": "allow",
      "poster": _vm.poData.images[0].url,
      "src": _vm.poData.images[1].url
    },
    on: {
      "click": _vm.playVideo,
      "ended": _vm.ended
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "video-btn",
    attrs: {
      "hidden": _vm.playing
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.playVideo($event)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "post-info-bottom"
  }, [_c('div', {
    staticClass: "post-info-left"
  }, [_c('div', {
    staticClass: "likers"
  }, _vm._l((_vm.poData.praise), function(item, index) {
    return (index < 3) ? _c('img', {
      key: index,
      staticClass: "likers-avatar",
      attrs: {
        "src": item.face,
        "alt": "",
        "srcset": ""
      }
    }) : _vm._e()
  }), 0), _vm._v(" "), _c('span', [_vm._v(_vm._s(parseInt(_vm.poData.praise_count)) + "赞")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(parseInt(_vm.poData.collect_count)) + "收藏")])]), _vm._v(" "), _c('div', {
    staticClass: "post-info-right"
  }, [_c('span', [_vm._v(_vm._s(_vm.poData.views) + "阅读")])])])]) : _vm._e(), _vm._v(" "), (_vm.poData) ? _c('div', {
    staticClass: "post-info"
  }, [_c('div', {
    staticClass: "post-user"
  }, [_c('div', {
    staticClass: "post-user-left"
  }, [_c('img', {
    staticClass: "user-avatar",
    attrs: {
      "src": _vm.poData.user.face,
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "info"
  }, [_c('span', {
    class: 'user-nickname ' + 'sex_' + _vm.poData.user.gender
  }, [_vm._v(_vm._s(_vm.poData.user.username))]), _vm._v(" "), _c('span', {
    staticClass: "user-po-time"
  }, [_vm._v(_vm._s(_vm._f("timestamp2txt")(_vm.poData.dateline)))])]), _vm._v(" "), _c('div', {
    staticClass: "post-identity"
  }, [_vm._l((_vm.poData.user.icons), function(item, index) {
    return _c('img', {
      key: index,
      staticClass: "post-medal",
      attrs: {
        "src": item,
        "alt": ""
      }
    })
  }), _vm._v(" "), _vm._l((_vm.poData.user.medals), function(item, index) {
    return _c('img', {
      key: item.medal_id,
      staticClass: "post-medal",
      attrs: {
        "src": item.medal_icon,
        "alt": index
      }
    })
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "post-user-right"
  }, [(_vm.poData.tag.tag_stick || _vm.poData.sticker) ? _c('img', {
    staticClass: "po-sticker",
    attrs: {
      "src": _vm.poData.tag.tag_stick || _vm.poData.sticker,
      "alt": ""
    }
  }) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "post-content"
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.poData.tag && _vm.poData.tag.tag_id),
      expression: "poData.tag && poData.tag.tag_id"
    }],
    staticClass: "tag",
    on: {
      "click": function($event) {
        return _vm.toTag(_vm.poData.tag.tag_id)
      }
    }
  }, [_vm._v("#" + _vm._s(_vm.poData.tag.tag_name) + " ")]), _vm._v(" "), _c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.contentFilters(_vm.poData.content))
    }
  })]), _vm._v(" "), (_vm.poData.labels.length != 0) ? _c('div', {
    staticClass: "post-tags"
  }, [_c('span', {
    staticClass: "tag-icon margin"
  }), _vm._v(" "), _vm._l((_vm.poData.labels), function(item, index) {
    return _c('span', {
      key: index,
      staticClass: "tag margin",
      on: {
        "click": function($event) {
          return _vm.toLabel(item.label_id)
        }
      }
    }, [_vm._v(_vm._s(item.label_name))])
  })], 2) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "lottery-content"
  }, [_c('p', {
    staticClass: "lottery-title"
  }, [_vm._v("Ta们赞了")]), _vm._v(" "), _c('div', {
    staticClass: "lottery-list"
  }, _vm._l((_vm.lotteries), function(item, index) {
    return _c('div', {
      staticClass: "list-item"
    }, [_c('span', {
      staticClass: "corner"
    }, [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('img', {
      staticClass: "lottery-img",
      attrs: {
        "src": item.face,
        "alt": ""
      }
    }), _vm._v(" "), _c('p', {
      staticClass: "lottery-username"
    }, [_vm._v(_vm._s(item.username))])])
  }), 0)])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@12.2.2@vue-loader/lib/template-compiler?{"id":"data-v-491847f3","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/_vue-loader@12.2.2@vue-loader/lib/selector.js?type=template&index=0!./src/pages/lottery/lottery.vue
// module id = 116
// module chunks = 1